<template>
  <div class="modal_wrap internet_quotation_list_modal" :class="{ on: isOpen }">
    <!--'on 추가'-->
    <div class="modal_inner">
      <div class="modal">
        <div class="modal_head">
          <h1 class="h1">가입신청서 작성하기</h1>
        </div>
        <div class="modal_sub_head">
          <h1 class="h1">가입신청서를 작성할 견적서를 선택해 주세요.</h1>
        </div>
        <div class="modal_con">
          <div
            class="quotation_con_list"
            @click="quotationSelect(item.id)"
            v-for="item in quotationList.content"
            :key="item.id"
            :id="item.id"
          >
            <div class="quo_date">
              {{ getCreateAt(item.createdAt) }}
            </div>
            <div class="con_box">
              <DetailInfo
                :item="item"
                :is-reverse="true"
                :isPromotionView="item.storeId == 4485"
              />
              <div class="more_info" v-if="item.memoSupport">
                <p v-html="$options.filters.nl2br(item.memoSupport)"></p>
              </div>
            </div>
          </div>
        </div>
        <div class="modal_btn">
          <div class="btn_wrap">
            <button class="btn bo grey" @click="close(false)">
              취소
            </button>
            <button class="btn" :disabled="btnDisabled" @click="close(true)">
              다음
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';
import DetailInfo from '@common/components/internetCommerce/DetailInfo.vue';

export default {
  name: 'internetQuotationListModal',
  components: { DetailInfo },
  props: {
    quotationList: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      isOpen: false,
      selectQuoId: 0,
      btnDisabled: true,
      isPromotionView: false,
    };
  },
  filters: {
    nl2br(val) {
      return String(val)
        .split('\n')
        .join('<br />');
    },
  },
  methods: {
    getCreateAt(createAt) {
      console.log('quotationList');
      console.log(this.quotationList);
      return format(parseISO(createAt), 'yyyy-MM-dd');
    },
    quotationSelect(id) {
      var listElement = document.querySelector('.quotation_con_list.on');

      if (listElement != null) {
        listElement.classList.remove('on');
      }
      var someElement = document.getElementById(id);
      someElement.classList.add('on');

      this.selectQuoId = id;
      this.btnDisabled = false;
    },
    close(dataType) {
      console.log(this.quotationList);
      this.$emit('close', dataType, this.selectQuoId);
    },
  },
};
</script>
